const OpposingArrowsVertical = () => (
  <>
    <path
      fill="currentColor"
      d="m16 18.075 2.746-2.746a.48.48 0 0 1 .707.006q.16.165.163.354a.49.49 0 0 1-.162.354l-3.389 3.388a.8.8 0 0 1-.267.184.8.8 0 0 1-.298.053.8.8 0 0 1-.298-.053.8.8 0 0 1-.268-.184l-3.388-3.388a.5.5 0 0 1-.15-.342.48.48 0 0 1 .15-.366q.166-.165.357-.166.19 0 .356.166L15 18.075V5.496q0-.213.143-.356a.48.48 0 0 1 .357-.144q.213 0 .357.144a.48.48 0 0 1 .143.356zM9 5.918v12.578a.48.48 0 0 1-.143.357.48.48 0 0 1-.357.143.48.48 0 0 1-.357-.143.48.48 0 0 1-.143-.357V5.918L5.254 8.664a.48.48 0 0 1-.707-.006.52.52 0 0 1-.163-.354.49.49 0 0 1 .162-.354l3.388-3.388a.8.8 0 0 1 .268-.184.8.8 0 0 1 .298-.053q.162 0 .298.053.136.052.267.184l3.389 3.388a.5.5 0 0 1 .15.342.48.48 0 0 1-.15.366.5.5 0 0 1-.357.165.5.5 0 0 1-.356-.165z"
    />
  </>
)
export default OpposingArrowsVertical
